import { Map } from 'immutable';
import { camelizeKeys } from 'humps';
import assign from 'lodash/assign';

import {
  ANSWERS__POST,
  CONDITIONS__COLLAPSE_ALL,
  CONDITIONS__CREATE,
  CONDITIONS__DELETE,
  CONDITIONS__FETCH,
  CONDITIONS__PATCH,
  CONDITIONS__REPLACE,
  CONDITIONS__UPDATE,
  RESULT__INIT,
  RESULT__FETCH,
  SURVEY_EDITOR__RESET,
  USER__LOG_OFF,
} from '../constants';

const defaultState = new Map({});

const deleteCondition = (state, conditionId) => state.delete(conditionId);

const setCondition = (state, condition) => state.merge({ [condition.id]: camelizeKeys(condition) });

const patchCondition = (state, conditionId, newProps) => {
  const patchData = assign({}, newProps, { patched: Date.now() });
  return state.mergeIn([conditionId], patchData);
};
const deepMergeConditions = (state, data) =>
  data.reduce((accState, { rules, ...condition }) => {
    return accState.mergeIn([condition.id], camelizeKeys(condition));
  }, state);
const parseResolvedConditions = (conditions) =>
  conditions.reduce(
    (newState, condition) => newState.merge({ [condition.id]: condition }),
    defaultState,
  );

export default function (state = defaultState, action) {
  switch (action.type) {
    case ANSWERS__POST:
    case RESULT__INIT:
    case RESULT__FETCH:
      return parseResolvedConditions(action.data.conditions);
    case CONDITIONS__COLLAPSE_ALL:
      return state.map((condition) =>
        condition.merge({
          expand: false,
          expandRuleForm: false,
        }),
      );
    case CONDITIONS__CREATE:
      return setCondition(state, {
        ...action.data,
        expand: true,
        expandRuleForm: true,
      });
    case CONDITIONS__REPLACE:
      return setCondition(state, action.data);
    case CONDITIONS__DELETE:
      return deleteCondition(state, action.conditionId);
    case CONDITIONS__FETCH:
      return deepMergeConditions(state, action.data);
    case CONDITIONS__PATCH:
      return patchCondition(state, action.condition.id, action.newProps);
    case CONDITIONS__UPDATE:
      return patchCondition(state, action.data.id, action.data);
    case SURVEY_EDITOR__RESET:
    case USER__LOG_OFF:
      return defaultState;
    default:
      return state;
  }
}
